<template>
  <div>
    <div class="banner">
      <div class="main">
        <div class="bg1"></div>
        <div class="bg2"></div>
        <div class="crumbs">
          <span class="link" @click="goCourseCenter(0)">课程中心</span>
          <template v-if="courseDetails.id">
            <template v-if="courseDetails.category_info">
              <i class="el-icon-arrow-right"></i>
              <span
                class="link"
                @click="goCourseCenter(courseDetails.category_info.id)"
                >{{ courseDetails.category_info.name }}</span
              >
            </template>
            <i class="el-icon-arrow-right"></i>
            <span>{{ courseDetails.name || '' }}</span>
          </template>
        </div>
        <div class="box">
          <div class="left">
            <el-image class="cover" fit="cover" :src="courseDetails.cover_pc" />
          </div>
          <div class="right">
            <div class="ziying">
              <div>
                <div>官方自营</div>
                <div>
                  {{ courseDetails.type_name || '' }}
                </div>
              </div>
            </div>
            <div class="title line-1">{{ courseDetails.name || '' }}</div>
            <div class="desc line-1">{{ courseDetails.description || '' }}</div>
            <div class="teachers">
              <span>100课程</span>
              <span>｜</span>
              <span>讲师：</span>
              <span class="heads">
                <el-image
                  v-for="(i, k) in courseDetails.teachers"
                  :key="k"
                  fit="cover"
                  :src="i.headpic"
                />
              </span>
            </div>
            <div class="bottom">
              <div class="price">
                <span class="yuan">¥</span>
                <span class="money">{{ courseDetails.sell_price * 1 }}</span>
                <span class="line">官方原价</span>
              </div>
              <div class="buttons">
                <!-- <el-button @click="intentionVisible = true">咨询</el-button> -->
                <el-button class="b1">咨询</el-button>
                <el-button class="b2" type="primary">报名学习</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="main course-main">
        <div class="left" v-html="courseDetails.content"></div>
        <div class="right">
          <div class="step">
            <div class="head">平台服务</div>
            <div class="list">
              <div v-for="(i, k) in servers" :key="k" class="item">
                <div class="l">
                  <el-image :src="require('@/assets/img/' + i.icon)" />
                </div>
                <div class="r">
                  <div class="title">{{ i.title }}</div>
                  <div class="desc">{{ i.desc }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="likeCourses.length > 0" class="related">
            <div class="head">猜你喜欢</div>
            <div class="list">
              <div
                v-for="(i, k) in likeCourses"
                :key="k"
                class="item"
                @click="goCourseDetails(i.id)"
              >
                <el-image class="cover" fit="cover" :src="i.cover_pc" />
                <div class="info">
                  <div class="title line-1">{{ i.name }}</div>
                  <div class="desc line-2">{{ i.description }}</div>
                  <div class="hotnum">
                    <icon-svg icon-class="icon_kecheng_1" />
                    <span>{{ i.learn_num }}人报名</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      title="报名咨询"
      :visible.sync="intentionVisible"
      width="500px"
    >
      <el-form
        ref="intentionform"
        label-width="80px"
        :model="intentionForm"
        :rules="intentionRules"
      >
        <el-form-item label="您的姓名" prop="name">
          <el-input v-model="intentionForm.name" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="intentionForm.phone" type="number" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="intentionVisible = false">取 消</el-button>
        <el-button type="primary" @click="intentionSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 轮播图子组件
import { getSubjectDetails, getLikeCourses } from '@/network/request'
export default {
  name: 'CourseDetails',
  data() {
    return {
      course_id: 0,
      courseDetails: {},
      likeCourses: [],
      servers: [
        {
          icon: 'icon-sv1.png',
          title: '社群答疑',
          desc: '专属答疑社群，有助教老师跟',
        },
        {
          icon: 'icon-sv2.png',
          title: '7×24服务',
          desc: '专属答疑社群，有助教老师跟',
        },
        {
          icon: 'icon-sv3.png',
          title: '系统全面',
          desc: '专属答疑社群，有助教老师跟',
        },
        {
          icon: 'icon-sv4.png',
          title: '同频交流',
          desc: '专属答疑社群，有助教老师跟',
        },
        {
          icon: 'icon-sv5.png',
          title: '工作机会',
          desc: '专属答疑社群，有助教老师跟',
        },
      ],

      intentionVisible: false,
      intentionForm: {
        name: '',
        phone: '',
        source: 'pc',
      },
      intentionRules: {
        name: [{ required: true, message: '请填写您的姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请填写您的手机号', trigger: 'blur' },
          {
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  watch: {
    $route: {
      immediate: true,
      handler(e) {
        this.course_id = parseInt(e.params.course_id || 0)
        this.intentionVisible
        this.loadCourse()
      },
    },
  },
  mounted() {},
  methods: {
    async loadCourse() {
      const detailsRes = await getSubjectDetails(this.course_id, false)
      this.courseDetails = detailsRes.data.result

      const likeRes = await getLikeCourses({
        course_id: this.course_id,
        cate_id: this.courseDetails.category_id,
        num: 3,
      })
      this.likeCourses = likeRes.data.result
    },
    goCourseCenter(cateId = 0) {
      this.$router.push({
        name: 'CourseCenter',
        params: {
          cate_id: cateId || 0,
        },
      })
    },
    goCourseDetails(courseId) {
      this.$router.push({
        name: 'CourseDetails',
        params: {
          course_id: courseId,
        },
      })
    },
    intentionClose() {},
    intentionSubmit() {
      this.$refs['intentionform'].validate((valid) => {
        if (valid) {
          this.$message.success('已收到您的信息')
          this.intentionVisible = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.touchBar-blank) {
  height: 73px !important;
}
::v-deep(.touchBar) {
  background-color: #fff !important;
}
.main {
  width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
}
.banner {
  width: 100%;
  min-width: 1240px;
  height: 376px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  background: #fff;
  overflow-x: hidden;

  .main {
    & > * {
      position: relative;
      z-index: 5;
    }

    .bg1 {
      position: absolute;
      width: 500px;
      height: 200px;
      border-radius: 50%;
      left: -160px;
      top: -100px;
      z-index: 0;
      background: #f9f9ff;
      box-shadow: 0 0 100px 100px #f9f9ff;
      // background: red;
      // box-shadow: 0 0 100px 100px red;
    }
    .bg2 {
      position: absolute;
      width: 1500px;
      height: 600px;
      border-radius: 50%;
      left: 73%;
      top: -500px;
      z-index: 0;
      background: #ecf6ff;
      box-shadow: 0 0 100px 200px #ecf6ff;
    }
  }
  .crumbs {
    line-height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    padding: 20px 0;
    .el-icon-arrow-right {
      margin: 0 6px;
      font-size: 10px;
    }
    & > span.link {
      cursor: pointer;
      &:hover {
        color: #209cff;
      }
    }
  }
  .box {
    width: 100%;
    height: 280px;
    display: flex;

    .left {
      margin-right: 43px;
      height: 100%;
      .cover {
        background: #fafafa;
        width: 490px;
        height: 100%;
        background: #4d37da;
        border-radius: 6px;
      }
    }
    .right {
      flex: 1;
      padding-top: 8px;
      .ziying {
        margin-bottom: 16px;
        & > div {
          display: inline-flex;
          height: 22px;
          line-height: 22px;
          border-radius: 4px;
          overflow: hidden;
          color: #fff;
          background: linear-gradient(to bottom, #1e2023 50%, #ff592a 0);
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffffff;

          & > div {
            &:first-child {
              padding: 0 7px 0 6px;
              background: #ff592a;
              border-radius: 0 11px 0 0;
            }
            &:last-child {
              min-width: 60px;
              padding: 0 6px 0 9px;
              background: #1e2023;
              border-radius: 0 0 0 11px;
              text-align: center;
            }
          }
        }
      }
      .title {
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1e2023;
        line-height: 42px;
        margin-bottom: 13px;
      }
      .desc {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #959595;
        line-height: 25px;
        margin-bottom: 26px;
      }
      .teachers {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #959595;
        line-height: 25px;
        display: flex;
        .heads {
          display: flex;
          .el-image {
            width: 26px;
            height: 26px;
            background: #d8d8d8;
            border: 1px solid #979797;
            border-radius: 13px;
            margin-right: 9px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .bottom {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .price {
          font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
          .yuan {
            font-size: 30px;
            font-weight: bold;
            color: #ff440f;
            line-height: 42px;
            margin-right: 2px;
          }
          .money {
            font-size: 44px;
            font-weight: bold;
            color: #ff440f;
            line-height: 60px;
          }
          .line {
            font-size: 18px;
            font-weight: 400;
            color: #bababa;
            line-height: 25px;
            margin-left: 6px;
            text-decoration: underline;
          }
        }
        .buttons {
          display: flex;
          .el-button {
            min-width: 120px;
            height: 54px;
            line-height: 54px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            border-radius: 10px;
            padding: 0;
            margin: 0 0 0 22px;
            &.b1 {
              width: 121px;
              border: 1px solid #008eff;
              font-size: 18px;
              color: #008eff;
            }
            &.b2 {
              width: 177px;
              border: none;
              font-size: 18px;
              color: #fff;
              background-color: #008eff;
              &:hover {
                background: #66b1ff;
              }
            }
          }
        }
      }
    }
  }
}
.body {
  width: 100%;
  min-width: 1240px;
  min-height: 400px;
  background: linear-gradient(180deg, #fff 0px, #fafafa 400px, #fafafa 100%);
}
.course-main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .left {
    flex: 1;
    min-height: 800px;
    padding: 30px;
    background-color: #fff;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    ::v-deep(p) {
      margin: 10px 0;
    }
  }

  .right {
    width: 350px;
    margin-left: 40px;
    .step {
      width: 100%;
      padding: 25px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 12px;

      .head {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 28px;
      }
      .list {
        .item {
          position: relative;
          display: flex;
          margin-bottom: 25px;
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 4px;
          }
          .l {
            margin-right: 6px;
            .el-image {
              width: 30px;
              height: 30px;
            }
          }
          .r {
            .title {
              font-size: 17px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #1e2023;
              line-height: 24px;
              margin-bottom: 4px;
            }
            .desc {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #959595;
              line-height: 21px;
            }
          }
        }
      }
    }
    .related {
      width: 100%;
      padding: 25px;
      background-color: #fff;
      border-radius: 12px;
      border: 1px solid #e5e5e5;
      margin-top: 30px;
      .head {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 28px;
      }
      .list {
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          position: relative;
          cursor: pointer;

          &::after {
            content: '';
            position: absolute;
            height: 1px;
            width: calc(100% - 130px);
            bottom: -15px;
            right: 0;
            background-color: #e4e4e4;
          }
          &:last-child {
            margin-bottom: 5px;
            &::after {
              display: none;
            }
          }

          .cover {
            width: 110px;
            height: 110px;
            margin-right: 20px;
            border-radius: 6px;
          }
          .info {
            flex: 1;
            overflow: hidden;
            .title {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              line-height: 25px;
              margin-bottom: 8px;
            }
            .desc {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #828282;
              line-height: 18px;
              height: 36px;
            }
            .hotnum {
              margin-top: 10px;
              .icon-svg {
                margin-right: 3px;
              }
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #828282;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
